<template>
  <common-dialog
    @opened="onOpened"
    ref="dialog"
    :title="title"
    width="1300px"
    :in-dialog="inDialog"
  >
    <list
      ref="list"
      common
      :show-checkbox="multiple"
      :show-status="showstatus"
      :checkbox-fixed="false"
      :isDialog="true"
    >
      <template #column>
        <slot name="column" />
        <el-table-column
          label="操作"
          align="center"
          width="60"
          v-if="selectable && !multiple"
        >
          <template slot-scope="{ row }">
            <el-button
              @click="selectItem(row)"
              type="text"
              v-if="ChooseIds.indexOf(row.RecordId) == -1"
              >选择</el-button
            >
            <el-button type="text" disabled v-else>已选择</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="choosetable" v-if="ChooseIds.length > 0">
      <div style="margin-bottom: 10px">
        已选产品数量：{{ ChooseModelIds.length }}
      </div>
      <el-table
        ref="table"
        class="tb-c-head"
        :data="ChooseData"
        border
        @expand-change="expandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <div class="customDiv1">
              <el-row class="mb0">
                <el-table
                  :data="row.OrderGoods"
                  border
                  show-summary
                  :summary-method="summaryCount"
                  style="margin: 10px auto"
                >
                  <el-table-column
                    prop="GoodsCode"
                    label="商品编号"
                    align="center"
                  />
                  <el-table-column
                    prop="GoodsName"
                    label="商品名称"
                    align="center"
                  />
                  <el-table-column
                    prop="AttributeName"
                    label="规格型号"
                    align="center"
                  />
                  <el-table-column
                    prop="AttributeCode"
                    label="货号"
                    align="center"
                  />
                  <el-table-column
                    prop="MainunitCount"
                    label="应发数量"
                    align="center"
                  />

                  <el-table-column
                    prop="SendCount"
                    label="已发数量"
                    align="center"
                  />
                  <el-table-column
                    prop="SendCount"
                    label="未发货数量"
                    align="center"
                    min-width="115"
                  >
                    <template slot-scope="{ row }">
                      {{
                        Number(
                          (row.MainunitCount - (row.SendCount || 0)).toFixed(2)
                        )
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    width="60"
                    v-if="selectable && !multiple"
                  >
                    <template slot-scope="{ row, $index }">
                      <el-button
                        @click="selectItem2(row)"
                        type="text"
                        v-if="ChooseModelIds.indexOf(row.RecordId) == -1"
                        >选择</el-button
                      >

                      <el-button
                        v-else
                        @click="chanelItem2(row, $index)"
                        type="text"
                        style="color: red"
                        >取消</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <!--expand End-->
        <el-table-column
          prop="OrderNo"
          label="订单编号"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="OrderDate"
          label="订单日期"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="NickName"
          label="用户昵称"
          align="center"
          min-width="140"
        />
        <el-table-column
          prop="ReceivingPerson"
          label="收货人"
          align="center"
          min-width="150"
        />

        <el-table-column
          prop="ReceivingAddress"
          label="收货地址"
          width="80"
          align="center"
        />

        <el-table-column
          label="操作"
          align="center"
          width="60"
          v-if="selectable && !multiple"
        >
          <template slot-scope="{ row, $index }">
            <el-button @click="chanelItem(row, $index)" type="text" style="color:red"
              >取消</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template slot="footer">
      <el-button type="primary" size="small" @click="submitmul">提交</el-button>
    </template>
  </common-dialog>
</template>
  <script>
import commonDialog from "@/components/common/dialog";
import list from "./sendlist";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "订单列表",
    },
    showstatus: {
      type: Boolean,
      default: true,
    },
    sameBusiness: {
      type: Boolean,
      default: false,
    },
    pickChild: {
      type: Boolean,
      default: false,
    },
    // custype: {
    //   type: String,
    //   default: "待生产"
    // }
  },
  data() {
    return {
      ChooseIds: [],
      ChooseData: [],
      checkRow: [],
      ChooseModelIds: [],
      ChooseModelData: [],
    };
  },
  methods: {
    onTbSelect(selection, row) {
      console.log("ontbselect");
      if (this.checkRow.length > 0) {
        this.checkRow.forEach((e, index) => {
          if (row.RecordId == e.RecordId) {
            this.checkRow.splice(index, 1);
            return;
          }
          if (index == this.checkRow.length - 1) {
            this.checkRow.push(row);
          }
        });
      } else {
        this.checkRow.push(row);
      }
    },
    selectAll(selection, recordId) {
      if (selection.length > 0) {
        selection.forEach((n) => {
          var has = false;
          this.checkRow.forEach((e) => {
            if (n.RecordId == e.RecordId) {
              has = true;
            }
          });
          if (!has) {
            this.checkRow.push(n);
          }
        });
      } else {
        for (let i = 0; i < this.checkRow.length; i++) {
          var e = this.checkRow[i];
          if (e.RecordId == orderId) {
            this.checkRow.splice(i, 1);
            i--;
          }
        }
      }
    },
    expandChange(row, t) {
      var has = false;
      t.forEach((e) => {
        if (e.RecordId == row.RecordId) {
          has = true;
          return;
        }
      });
      if (!has) {
        return;
      }
      this.checkRow.forEach((e) => {
        if (e.RecordId == row.RecordId) {
          this.$nextTick(() => {
            this.$refs["prod" + row.RecordId].toggleRowSelection(e, true);
          });
        }
      });
    },
    onOpened(data) {
      this.ChooseIds = [];
      this.ChooseData = [];
      this.checkRow = [];
      this.ChooseModelData = [];
      this.ChooseModelIds = [];
      // this.$refs.list.params.OrderStatus = this.custype
      // this.query();
    },
    selectItem(row) {
      this.ChooseIds.push(row.RecordId);
      this.ChooseData.push(row);
      console.log("this.ChooseData", this.ChooseData);

      this.ChooseData.map((item) => {
        if (row.RecordId == item.RecordId) {
          row.OrderGoods.forEach((item) => {
            item.Quantity = item.MainunitCount - (item.SendCount || 0);
          });
        }
      });
    },
    chanelItem(row, index) {
      this.ChooseData.splice(index, 1);
      this.ChooseIds.splice(index, 1);
      this.ChooseModelData.forEach((e, index) => {
        if (e.OrdermainId == row.RecordId) {
          this.ChooseModelData.splice(index, 1);
        }
      });
      this.ChooseModelIds = this.ChooseModelData.map((item) => item.RecordId);
    },
    selectItem2(row) {
      this.ChooseModelIds.push(row.RecordId);
      this.ChooseModelData.push(row);
      console.log("this.ChooseModelData", this.ChooseModelData);
    },
    chanelItem2(row, index) {
      console.log("chanelItem2", row);
      this.ChooseModelIds.forEach((e, index) => {
        if (e == row.RecordId) {
          this.ChooseModelIds.splice(index, 1);
        }
      });
      this.ChooseModelData.forEach((e, index) => {
        if (e.RecordId == row.RecordId) {
          this.ChooseModelData.splice(index, 1);
        }
      });
      if (this.ChooseData.length > 0) {
        this.ChooseData.forEach((e, index) => {
          if (e.RecordId == row.OrdermainId) {
            var length = this.ChooseModelData.filter(
              (x) => x.OrdermainId == e.RecordId
            ).length;

            if (length < 1) {
              this.ChooseData.splice(index, 1);
            }
          }
        });
        this.ChooseIds = this.ChooseData.map((item) => item.RecordId);
      }
    },
    submitmul() {
      var issumit = true;
      if (this.ChooseData.length > 0) {
        if (this.ChooseModelData.length < 1) {
          this.$message.error("请选择发货商品");
          return false;
        }
        if (this.sameBusiness) {
          //限制同个客户
          var personId = this.ChooseData[0].PersonId;
          this.ChooseData.forEach((e) => {
            if (e.PersonId != personId) {
              issumit = false;
              this.$message.warning("需要选择同个用户");
            }
          });
        }
        if (issumit) {
          // var list = []
          //  this.ChooseData.map((x,i) =>{
          //   x.detailData.map((item,index)=>{
          //     this.checkRow.map((k,j) =>{
          //       if(k.OrderDetailId == item.OrderDetailId){
          //         list.splice(index,1)
          //       }else{
          //         list.push(row[0])
          //       }
          //     })
          //   })
          // })
          // this.onSelect(this.checkRow);

          // this.checkRow.forEach((e) => {
          //   arr.forEach((n) => {
          //     if (n.OrderId == e.OrderId) {
          //       n.OrderDetail.push(e);
          //     }
          //   });
          // });
          this.ChooseModelData.forEach((item) => {
            var ordermain = this.ChooseData.find(
              (x) => x.RecordId == item.OrdermainId
            );
            if (ordermain) {
              item.OrderNo = ordermain.OrderNo;
              item.OrderDate = ordermain.OrderDate;
            }
          });
          var arr2 = {
            StoreId: this.ChooseData[0].StoreId,
            ReceivingPerson: this.ChooseData[0].ReceivingPerson,
            ReceivingAddress: this.ChooseData[0].ReceivingAddress,
            ReceivingPhone: this.ChooseData[0].ReceivingPhone,
            OrderGoods: this.ChooseModelData,
          };
          // console.log(arr2)
          // return;
          this.ChooseData = [];
          this.ChooseIds = [];
          this.checkRow = [];
          this.ChooseModelIds = [];
          this.ChooseModelData = [];
          console.log("arr2", arr2);
          this.onSelect(arr2);
          // this.onSelect(this.ChooseData);
        }
      } else {
        this.$message.warning("请选择订单");
      }
    },
    summaryCount(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.label == "总长度") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(((prev * 1000 + curr * 1000) / 1000).toFixed(4));
            } else {
              return Number(prev - 0).toFixed(4);
            }
          }, 0);
        } else if (column.label == "主单位数量") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
        } else if (column.label == "辅助单位数量") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "-";
        }
      });
      return sums;
    },
  },
};
</script>
  <style lang="scss" scoped>
.choosetable {
  margin: 10px;
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
  /deep/ .el-card__header {
    padding: 10px 20px;
  }
}
</style>
  